module.exports = __webpack_public_path__ + "static/media/logo2.6a7dbac1.png";